<template>
    <div>
        <div class="mt-3 mb-4 comentarios" v-if="comentarios.length" ref="comentariosDiv">
            <div class="item-comentario"
                :class="{ 'item-destaque': comentario.data && comentario.read_at == null
                && JSON.parse(comentario.data).component && JSON.parse(comentario.data).component != 'tarefa-encaminhada'
                ? true : false }"
                v-for="(comentario, commentIndex) in comentariosFilter" :key="comentario.id">

                <div style="font-size: 14px; word-wrap: break-word;">
                    <div><strong v-if="comentario.colaborador">{{ comentario.colaborador.name }}</strong>
                        <strong v-else>Econsulte</strong>

                        <span v-if="comentario.action">{{ comentario.action.name }}
                            {{ comentario.reply ? comentario.reply.name : "" }}:</span>
                        <span v-else-if="comentario.anexo">anexou:</span>
                        <span v-if="comentario.reply && comentario.reply.comentario">respondeu:</span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div style="flex:auto">
                            <div class="reply" v-if="comentario.reply && comentario.reply.comentario">
                                <div v-if="comentario.reply"><small>{{ comentario.reply.colaborador.name }}</small></div>
                                <span v-html="comentario.reply.comentario"></span>
                            </div>

                            <span v-html="comentario.comentario"></span>

                            <span v-if="comentario.tarefa_checklist_item_status && comentario.tarefa_checklist_item_status.tarefa_checklist_item && comentario.tarefa_checklist_item_status.tarefa_checklist_item.item">
                                <b>{{ comentario.tarefa_checklist_item_status.colaborador.name }}</b> o item {{ comentario.tarefa_checklist_item_status.tarefa_checklist_item.item.nome}}
                            </span>

                            <span v-if="comentario.anexo && !!comentario.anexo.upload && parceiro.user_id != 7"><a href="#" class="mr-2"
                                    @click.prevent="preview(comentario.anexo.upload)"
                                    v-if="IsCanView(comentario.anexo.upload)"><u>Visualizar</u></a>
                                <a class="mr-2" :href="`/api/download/${comentario.anexo.upload.id}`"
                                    :download="comentario.anexo.upload.arquivo_name"
                                    target="_blank"><u>Download</u></a></span>
                        </div>


                        <b-button style="align-self: flex-end;"
                            v-if="checkComponent(comentario, 'delegatedChecklist') && comentario.notifiable_id == user.user_id && comentario.read_at == null" variant="primary"
                            @click="reply_id = JSON.parse(comentario.data).model.id; reply = JSON.parse(comentario.data).model.comentario; notification_id = comentario.notification_id; atender(comentario)">Atender</b-button>
                        <div style="align-self: flex-end;"
                            v-else-if="checkComponent(comentario, 'delegatedChecklist') && comentario.data && comentario.read_at == null && comentario.notifiable_id != user.user_id">
                            <strong><i>Aguardando atendimento</i></strong>
                        </div>

                        <b-button style="align-self: flex-end;"
                            v-if="checkComponent(comentario, 'mention') && comentario.notifiable_id == user.user_id && comentario.read_at == null" variant="primary"
                            @click="reply_id = JSON.parse(comentario.data).model.id; reply = JSON.parse(comentario.data).model.comentario; notification_id = comentario.notification_id; $bvModal.show('replyModal')">Responder</b-button>
                        <div style="align-self: flex-end;"
                            v-else-if="checkComponent(comentario, 'mention') && comentario.data && comentario.read_at == null && comentario.notifiable_id != user.user_id">
                            <strong><i>Aguardando resposta</i></strong>
                        </div>
                    </div>

                </div>
                <div>
                    <small>{{
                        moment(comentario.created_at).format("DD/MM/YYYY HH:mm:ss")
                    }}</small>
                </div>

            </div>


        </div>

        <modal id="replyModal" size="md" title="Responder comentário">
            <p v-html="reply"></p>
            <Comentario :tarefa_id="tarefa_id" :reply_id="reply_id" :notification_id="notification_id"></Comentario>
        </modal>
        <eFilePreview v-if="visualizar.id != ''" :title="visualizar.name" :id="`preview-${visualizar.id}`"
            :file="visualizar.link" />

    </div>
</template>
<script>

import { mapState, mapMutations } from 'vuex';
import eFilePreview from '../sistema/eFilePreview.vue';
import Comentario from "./forms/Comentario.vue";

export default {
    components: { eFilePreview, Comentario },
    props: {
        value: false,
        tarefa_id: { type: Number, required: true },
        scrollTo: { default: 'top' },
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.getComentarios();
                this.$emit('input', false);
            }
        }
    },
    data() {
        return {
            comentarios: [],
            visualizar: {
                id: "",
                name: "",
                link: "",
            },
            reply_id: null,
            notification_id: null,
            reply: null,
        }
    },
    created() {
        this.getComentarios();

        this.$root.$on('getComentarios', () => {
            this.getComentarios();
        });
    },

    computed: {
        ...mapState('user', ['user', 'parceiro']),

        comentariosFilter() {
            let comentarios = this.comentarios.sort((a, b) => {
                if (a.data && a.read_at == null && a.notifiable_id == this.user.user_id && b.data == null && JSON.parse(a.data).component && JSON.parse(a.data).component != 'tarefa-encaminhada') {
                    return -1;
                } else if (b.data && b.read_at == null && b.notifiable_id == this.user.user_id && a.data == null ) {
                    return 1;
                } else if (a.data && a.read_at == null && a.notifiable_id == this.user.user_id && b.data) {
                    return -1;
                } else if (b.data && b.read_at == null && a.notifiable_id == this.user.user_id && a.data) {
                    return 1;
                } else if (a.data && a.read_at == null && a.notifiable_id != this.user.user_id && b.data == null && JSON.parse(a.data).component && JSON.parse(a.data).component != 'tarefa-encaminhada') {
                    return -1;
                } else if (b.data && b.read_at == null && a.notifiable_id != this.user.user_id && a.data == null) {
                    return 1;
                } else {
                    return 0;
                }
            });

            if (this.scrollTo == "top") {
                comentarios = comentarios;
            } else if (this.scrollTo == "bottom") {
                comentarios = comentarios.reverse();
            }

            return comentarios;
        }
    },
    methods: {
        async atender(comentario){
            await this.$api.put(`tarefa-checklist-item-status/${comentario.tarefa_checklist_item_status_id}`,
            {
               situacao_id: 3//executando
            });

            this.$emit('updateCartao');
        },
        checkComponent(comentario, component){
         const parsedData = JSON.parse(comentario.data)

            if (parsedData && parsedData.component == component)
                return true

            return false
        },
        async getComentarios() {
            let result = await this.$api.get(`tarefa-comentario/${this.tarefa_id}`);

            this.comentarios = result.data;


            this.$nextTick(() => {
                // access the comments div using $refs and scroll to the bottom
                if (this.scrollTo == 'top' && this.$refs.comentariosDiv) {
                    this.$refs.comentariosDiv.scrollTo(0, 0);
                } else if (this.scrollTo == 'bottom' && this.$refs.comentariosDiv) {
                    this.$refs.comentariosDiv.scrollTo(0, this.$refs.comentariosDiv.scrollHeight);
                }
            });

        },

        IsCanView(anexo) {
            let visualizar = false;
            switch (anexo.arquivo_name.split(".").pop()) {
                case "png":
                case "jpg":
                case "jpeg":
                case "gif":
                case "txt":
                case "doc":
                case "docx":
                case "pdf":
                    visualizar = true;
                    break;
            }

            return visualizar;
        },
        async preview(anexo) {
            const result = await this.$api.get(`anexos/${anexo.id}`);

            this.visualizar.id = "";
            this.visualizar.link = "";
            this.visualizar.name = anexo.arquivo_name;
            this.visualizar.id = anexo.id;
            this.visualizar.link = result.data.link;

            setTimeout(() => {
                this.$bvModal.show(`preview-${this.visualizar.id}`);
            }, 100);
        },
        reply() {

        }


    },
}
</script>
<style scoped>
.comentarios {
    overflow-x: hidden;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    background-color: #fafafa;

    padding: 20px;
    height: 400px;
}

.item-destaque {
    border-bottom: 1px solid #ccc;
    background-color: #fff;
}

.item-comentario {

    border-radius: 7.5px;
    max-width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    word-wrap: break-word;
    margin-bottom: 10px;
}

.reply {
    background-color: #e8e8e8;
    padding: 10px;
    border-left: 2.5px solid #3498db;
    border-radius: 5px;
}
</style>
